import { DEFAULT_HARDWARE_CHECKOUT_COUNTRY } from "../../shippingCountries";
import type { PixiWizardSelection } from "../../hooks/usePixiWizardState";
import {
  BillingCycle,
  CurrencyCode,
  DEFAULT_BILLING_CYCLE,
  DEFAULT_CURRENCY,
  DEFAULT_PLAN,
  PlanId,
} from "./constants";

export interface ResolvedSelection {
  planId: PlanId;
  currency: CurrencyCode;
  billingCycle: BillingCycle;
  shippingCountry: string;
  licenses: number;
}

/**
 * The single source of truth for the Plan & Billing selection: applies the
 * defaults and the Pro-trialist override (always Pro). Used by both the step
 * (cards/deals) and the wizard footer so they can never disagree.
 */
export const resolveSelection = (
  state: PixiWizardSelection,
  isProTrialist: boolean,
): ResolvedSelection => ({
  planId: isProTrialist ? "pro" : (state.planId ?? DEFAULT_PLAN),
  currency: state.currency ?? DEFAULT_CURRENCY,
  billingCycle: state.billingCycle ?? DEFAULT_BILLING_CYCLE,
  shippingCountry: state.shippingCountry ?? DEFAULT_HARDWARE_CHECKOUT_COUNTRY,
  licenses: state.screenCount,
});
